module.exports = __webpack_public_path__ + "img/stock0.f786e6b7.png";